<template>
  <div class="tab-section">
    <TabsHeader />
    <PonyTabs />
  </div>
</template>

<script>
import TabsHeader from '../TabsHeader/TabsHeader';
import PonyTabs from '../PonyTabs/PonyTabs';

export default {
  name: 'TabSection',
  components: {
    TabsHeader,
    PonyTabs
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/sass/config';

.tab-section {
  background-color: $teal;
  padding: 40px 10px;
  color: $text-color;
}
</style>

